let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bnI4A")).then(() => parcelRequire('bwlUg'));